import { LayoutNav } from "@/Nav";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useNavVisibilityStore } from "&/navVisibility";
import { TermsConsentGate } from "@/common/TermsConsentGate";

export const Route = createFileRoute("/customer/layout")({
  component: Home,
});

function Home() {
  const navVisible = useNavVisibilityStore((s) => s.visible);
  return (
    <>
      {/* main(스크롤 컨테이너)을 채우는 flex 컬럼 — 각 화면은 flex-auto 로 채움.
          짧은 화면은 카드에 fit, 긴 화면은 main 이 스크롤 (vh 하드코딩 금지) */}
      <div className="flex min-h-0 flex-1 flex-col min-w-0 bg-[#F5F5F5]">
        <Outlet />
        {/* nav 여백은 padding-bottom 이 아니라 "실제 요소"여야 한다.
            이 래퍼는 min-h-0 + flex-1 이라 높이가 main 높이로 잠기고,
            콘텐츠가 넘치면 래퍼의 padding-bottom 은 넘친 콘텐츠 위(래퍼 하단)에 남아
            스크롤 끝에 여백이 생기지 않는다 → 마지막 항목이 nav 에 가림.
            shrink-0 스페이서는 플로우에 남아 main 의 스크롤 높이에 그대로 더해진다.
            높이는 nav 점유분(bottom + h-16)과 동일하게 맞춘다. */}
        {navVisible && (
          <div
            aria-hidden
            className="shrink-0 h-[calc(5.5rem+var(--nav-bottom,0px))] md:h-[7rem]"
          />
        )}
      </div>
      <LayoutNav type="customer" />
      {/* 약관 개정 시 재동의 모달 — 로그인 상태에서만 동작 */}
      <TermsConsentGate />
    </>
  );
}
